import module from 'catalogo/module.js'

const schema = {
  id: 'number',
  dias: 'number',
}

class CatalogoDiasVacacionesService {
  constructor ($http) {
    this.$http = $http
  }

  get () {
    return this.$http.get('/api/catalogo/dias_vacaciones', {
      cache: 'catalogo',
      schema,
    })
  }
}

module.service('CatalogoDiasVacaciones', CatalogoDiasVacacionesService)



// WEBPACK FOOTER //
// ./src/catalogo/services/Catalogo/DiasVacaciones.js